import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    templateUrl: 'loading.component.html',
    styleUrls: ['../message.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class LoadingComponent {}
